export default __webpack_public_path__ + "images/IK.eaadc92.png";